import { css, type SerializedStyles, type Theme } from '@emotion/react';

import { Typography } from '@toolbox/components';
import { useValuationContext } from '@widget/valuation';

import type { ReactElement } from 'react';

const classes = {
  root:
    ({ loading }: { loading: boolean }) =>
    (theme: Theme): SerializedStyles =>
      css`
        display: flex;
        text-align: center;
        opacity: ${loading ? 0.3 : 1};

        ${theme.media.up('md')} {
          display: block;
        }
      `,
  title: (theme: Theme): SerializedStyles => css`
    font-size: 0.875rem;
    margin-right: ${theme.spacing(1)};

    ${theme.media.up('md')} {
      font-size: 1rem;
      margin-right: 0;
    }
  `,
  text: (theme: Theme): SerializedStyles => css`
    font-size: 0.875rem;

    ${theme.media.up('md')} {
      font-size: 1.25rem;
    }
  `,
};

export const ValuationText = (): ReactElement | null => {
  const { valuation, loading } = useValuationContext();

  if (!valuation) return null;

  return (
    <div css={classes.root({ loading }) as any} aria-live="polite" aria-atomic="true">
      <Typography variant="b1" as="div" css={classes.title as any}>
        Bewertung
      </Typography>
      <Typography variant="b1" as="div" fw="bold" css={classes.text as any}>
        {valuation}
      </Typography>
    </div>
  );
};
